import React from 'react';
import { CircularProgress, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100px',
    },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    inline: {
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: '8px',
    }
});

const LoadingCircle = ({
                           size = 40,
                           overlay = false,
                           inline = false,
                           color = 'primary'
                       }) => {
    const classes = useStyles();

    const spinner = <CircularProgress size={size} color={color} />;

    if (overlay) {
        return (
            <div className={classes.overlay}>
                {spinner}
            </div>
        );
    }

    if (inline) {
        return (
            <span className={classes.inline}>
        {spinner}
      </span>
        );
    }

    return (
        <Box className={classes.loadingContainer}>
            {spinner}
        </Box>
    );
};

export default LoadingCircle;